var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "page-integrations" } },
    [
      _c("AppBreadCrumb", {
        attrs: {
          paths: [{ title: _vm.$t("message.integrations") }],
          select: true,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex right-page",
          staticStyle: { "background-color": "#ffffff" },
        },
        [
          _c(
            "div",
            { staticClass: "ml-3 mt-3", staticStyle: { flex: "0 0 100%" } },
            [
              _c("div", { staticClass: "big-title" }, [
                _vm._v(_vm._s(_vm.$t("message.allIntegrations"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stories" }, [
                _c("div", { staticClass: "story" }, [
                  _c("div", { staticClass: "status" }, [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v(" done "),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("message.installationOK")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "img supsis" },
                    [_c("SupsisIcon")],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("message.chatWidget"))),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "story",
                    on: {
                      click: function ($event) {
                        return _vm.$router.push("/integrations/webhook")
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "img webhooks" },
                      [_c("WebhookIcon")],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("message.webhooks"))),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("message.integrateSupsiswithIntegratable", {
                            integratable: "Webhooks",
                          })
                        ) + " ."
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _vm.multiWhatsapp &&
                _vm.checkPermission(
                  _vm.PERMISSION_TYPES["integrations.whatsapp.view"].tr.name
                )
                  ? _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/whatsapp-v1")
                          },
                        },
                      },
                      [
                        _vm.whatsappV1ChannelExists
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                    "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img whatsapp" },
                          [
                            _c("WhatsappV1", {
                              staticStyle: { width: "40px" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v("Whatsapp V1 (QR)"),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("message.integrationsWhatsappV1")) +
                              "\n                    "
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.multiWhatsapp &&
                _vm.checkPermission(
                  _vm.PERMISSION_TYPES["integrations.whatsapp.view"].tr.name
                ) &&
                _vm.istWhatsappV2()
                  ? _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/whatsapp-v2")
                          },
                        },
                      },
                      [
                        _vm.whatsappV2ChannelExists
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                    "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img whatsapp" },
                          [
                            _c(
                              "span",
                              { staticClass: "material-icons star-v2" },
                              [_vm._v(" star ")]
                            ),
                            _vm._v(" "),
                            _c("WhatsappV2", {
                              staticStyle: { width: "40px" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v("Multi Whatsapp V2 (QR)"),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("message.integrationsWhatsappV2")) +
                              "\n                    "
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.checkPermission(
                  _vm.PERMISSION_TYPES["integrations.whatsapp.view"].tr.name
                )
                  ? _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push(
                              "integrations/whatsapp-business-api"
                            )
                          },
                        },
                      },
                      [
                        _vm.whatsappBusinessChannelExists
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                    "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img whatsapp" },
                          [
                            _c("WhatsappBusinessIcon", {
                              staticStyle: { width: "50px" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v("Whatsapp Business API"),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t("message.integrationsWhatsappBusiness")
                              ) +
                              "\n                    "
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.checkPermission(
                  _vm.PERMISSION_TYPES["integrations.instagram.view"].tr.name
                )
                  ? _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/instagram")
                          },
                        },
                      },
                      [
                        _vm.instagramEnabled
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                    "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img instagram" },
                          [_c("InstagramIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v("Instagram"),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t(
                                  "message.integrateSupsiswithIntegratable",
                                  { integratable: "Instagram" }
                                )
                              ) +
                              "\n                        " +
                              _vm._s(
                                _vm.$t("message.planRequired", {
                                  integratable: "Instagram",
                                })
                              ) +
                              "\n                    "
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.checkPermission(
                  _vm.PERMISSION_TYPES["integrations.telegram.view"].tr.name
                )
                  ? _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            _vm.integrateTelegramModalVisible = true
                          },
                        },
                      },
                      [
                        _vm.telegramEnabled
                          ? _c("div", { staticClass: "status" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(" done "),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.installationOK")) +
                                  "\n                    "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "a-modal",
                          {
                            attrs: {
                              title: _vm.$t("telegram.telegramTokenTitle"),
                              wrapClassName: "vertical-center-modal",
                              visible: _vm.integrateTelegramModalVisible,
                            },
                            on: {
                              cancel: function ($event) {
                                return _vm.handleCancel()
                              },
                              ok: function ($event) {
                                return _vm.handleOk()
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col mb-5" },
                              [
                                _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "telegram.typeInTelegramToken"
                                      ),
                                    },
                                  },
                                  [
                                    _c(
                                      "a-modal",
                                      {
                                        attrs: {
                                          title: _vm.$t(
                                            "telegram.telegramAlertTitle"
                                          ),
                                        },
                                        on: {
                                          ok: _vm.confirmDeleteToken,
                                          cancel: _vm.cancelDeleteToken,
                                        },
                                        model: {
                                          value: _vm.visibleDeleteToken,
                                          callback: function ($$v) {
                                            _vm.visibleDeleteToken = $$v
                                          },
                                          expression: "visibleDeleteToken",
                                        },
                                      },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "telegram.telegramAlertText"
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "row mb-3" },
                                      [
                                        _c("a-input", {
                                          staticClass: "mt-2",
                                          class: {
                                            "err-class": _vm.showWarning,
                                          },
                                          staticStyle: { width: "90%" },
                                          attrs: {
                                            autofocus: "",
                                            placeholder:
                                              _vm.$t("telegram.token"),
                                          },
                                          on: {
                                            change: _vm.onTelegramTokenChange,
                                          },
                                          model: {
                                            value: _vm.tempToken,
                                            callback: function ($$v) {
                                              _vm.tempToken = $$v
                                            },
                                            expression: "tempToken",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _vm.isThereTempToken
                                          ? _c("a-button", {
                                              staticClass: "ml-2 p-10 mt-2",
                                              attrs: {
                                                type: "primary",
                                                icon: "delete",
                                              },
                                              on: {
                                                click:
                                                  _vm.showDeleteConfirmation,
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-alert",
                                  { attrs: { "show-icon": "", type: "info" } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "description" },
                                        slot: "description",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.$t(
                                                "telegram.telegramAlertForm"
                                              )
                                            ) +
                                            "\n                                    "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: "https://t.me/BotFather",
                                              target: "_blank",
                                            },
                                          },
                                          [_vm._v("BotFather")]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img telegram" },
                          [_c("TelegramIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [
                          _vm._v("Telegram"),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "message.integrateSupsiswithIntegratable",
                                { integratable: "Telegram" }
                              )
                            )
                          ),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isEmailFeatureEnabled()
                  ? _c(
                      "div",
                      {
                        staticClass: "story",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("integrations/mail")
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "img mail" },
                          [_c("MaliIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "title" }, [_vm._v("Mail")]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "message.integrateSupsiswithIntegratable",
                                { integratable: "Mail" }
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a-modal",
                          {
                            attrs: {
                              title: "Mail Entegre Et",
                              wrapClassName: "vertical-center-modal",
                              visible: _vm.integrateMailVisible,
                            },
                            on: {
                              cancel: function ($event) {
                                return _vm.handleCancelMail()
                              },
                              ok: function ($event) {
                                return _vm.handleOkMail()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.emailDomain) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "story",
                    on: {
                      click: function ($event) {
                        return _vm.$router.push("integrations/sms/postacell")
                      },
                    },
                  },
                  [
                    _vm.smsChannels.length > 0
                      ? _c("div", { staticClass: "status" }, [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v(" done "),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("message.installationOK")) +
                              "\n                    "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", { staticClass: "title" }, [
                      _vm._v("SMS - Postacell"),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v("Activate sending SMS via PostaCELL SMS Provider"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "story",
                    on: {
                      click: function ($event) {
                        return _vm.$router.push("integrations/openai")
                      },
                    },
                  },
                  [
                    _vm.openaiChannels.length > 0
                      ? _c("div", { staticClass: "status" }, [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v(" done "),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("message.installationOK")) +
                              "\n                    "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "img" }, [_c("OpenaiIcon")], 1),
                    _vm._v(" "),
                    _c("div", { staticClass: "title" }, [_vm._v("OpenAI")]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n                        Activate OpenAI Services - Chatbot AI Response - AI Assistant CoPilot - Chatbot AI Knowledge\n                        Base\n                    "
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "story voting",
                    on: { click: function ($event) {} },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "img facebook" },
                      [_c("FacebookIcon")],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "title" }, [_vm._v("Facebook")]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("message.integrateSupsiswithIntegratable", {
                            integratable: "Facebook",
                          })
                        )
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "story voting",
                    on: { click: function ($event) {} },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "img twitter" },
                      [_c("TwitterIcon")],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "title" }, [_vm._v("Twitter")]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("message.integrateSupsiswithIntegratable", {
                            integratable: "Twitter",
                          })
                        )
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "story voting",
                    on: { click: function ($event) {} },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "img skype" },
                      [_c("SkypeIcon")],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "title" }, [_vm._v("Skype")]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("message.integrateSupsiswithIntegratable", {
                            integratable: "Skype",
                          })
                        )
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "story voting",
                    on: { click: function ($event) {} },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "img shopify" },
                      [_c("ShopifyIcon")],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "title" }, [_vm._v("Shopify")]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("message.integrateSupsiswithIntegratable", {
                            integratable: "Shopify",
                          })
                        )
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "story voting",
                    on: { click: function ($event) {} },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "img slack" },
                      [_c("SlackIcon")],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "title" }, [_vm._v("Slack")]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("message.integrateSupsiswithIntegratable", {
                            integratable: "Slack",
                          })
                        )
                      ),
                    ]),
                  ]
                ),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img postacell" }, [
      _c("img", { attrs: { src: "/static/img/postacell-logo.png" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }